import React, { useEffect } from "react";
import { HomeNav as Navbar } from "@/components/home/HomeNav";
import { HomeFooter as Footer } from "@/components/home/ContactFooter";
import MobileStickyCTA from "@/components/portfolio/MobileStickyCTA";
import PricingHero from "@/components/pricing/PricingHero";
import PricingCards from "@/components/pricing/PricingCards";
import CarePlan from "@/components/pricing/CarePlan";
import AddOnsTable from "@/components/pricing/AddOnsTable";
import PricingFAQ from "@/components/pricing/PricingFAQ";
import PricingCTA from "@/components/pricing/PricingCTA";
import PackageQuiz from "@/components/pricing/PackageQuiz";
import { PRICING_FAQ } from "@/data/pricing";
import { useSeo } from "@/hooks/useSeo";

const PAGE_TITLE =
  "Pricing | £4,495 Signature Website for Building Firms | Jay Alminshawi";
const PAGE_DESCRIPTION =
  "The £4,495 Signature package: a complete website for building firms — renovation, construction, new build, kitchen & bathroom and extension companies. Bespoke design, project galleries, quote forms, CRM integrations and 30 days launch support.";

const FAQ_LD_ID = "pricing-faq-jsonld";

const PricingPage = () => {
  useSeo({ title: PAGE_TITLE, description: PAGE_DESCRIPTION, path: "/pricing" });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // FAQ rich-results structured data
    const ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: PRICING_FAQ.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    let s = document.getElementById(FAQ_LD_ID);
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = FAQ_LD_ID;
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);
    return () => {
      const el = document.getElementById(FAQ_LD_ID);
      if (el) el.remove();
    };
  }, []);

  return (
    <main
      data-testid="pricing-page"
      className="relative bg-[#09090b] text-white font-jakarta antialiased"
    >
      <Navbar />
      <PricingHero />
      <PricingCards />
      <PackageQuiz />
      <CarePlan />
      <AddOnsTable />
      <PricingFAQ />
      <PricingCTA />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
};

export default PricingPage;
